import { useState, FormEvent } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Input } from '@/components/ui';
import { updatePassword } from '../api/authApi';
import { useAuth } from '../hooks/useAuth';  // ADD THIS IMPORT

export function ResetPasswordForm() {
  const navigate = useNavigate();
  const { signOut } = useAuth(); 
  
  const [formData, setFormData] = useState({
    password: '',
    confirmPassword: '',
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const validatePassword = (): string | null => {
    if (formData.password.length < 8) {
      return 'Password must be at least 8 characters long';
    }
    if (formData.password !== formData.confirmPassword) {
      return 'Passwords do not match';
    }
    return null;
  };

  const handleSubmit = async (e: FormEvent) => {
  e.preventDefault();
  
  const validationError = validatePassword();
  if (validationError) {
    setError(validationError);
    return;
  }

  setIsLoading(true);
  setError(null);

  const result = await updatePassword({ password: formData.password });

  setIsLoading(false);

  if (result.error) {
    setError(result.error.message);
    return;
  }

  setIsSuccess(true);
  
  // Sign out after showing success message
  // signOut() will clear all state (including recovery mode) and redirect to login
  setTimeout(async () => {
    await signOut();
  }, 2500);
};

  const handleChange = (field: 'password' | 'confirmPassword') => (
    e: React.ChangeEvent<HTMLInputElement>
  ) => {
    setFormData((prev) => ({ ...prev, [field]: e.target.value }));
    if (error) setError(null);
  };

  if (isSuccess) {
    return (
      <div className="text-center space-y-4">
        <div className="w-16 h-16 bg-green-100 rounded-full flex items-center justify-center mx-auto">
          <svg
            className="w-8 h-8 text-green-600"
            fill="none"
            stroke="currentColor"
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth={2}
              d="M5 13l4 4L19 7"
            />
          </svg>
        </div>
        <h3 className="text-lg font-semibold text-secondary-900">
          Password updated successfully
        </h3>
        <p className="text-secondary-600 text-sm">
          Your password has been reset. You'll be redirected to sign in shortly.
        </p>
        <Button
          onClick={() => navigate('/login')}
          variant="outline"
          className="mt-4"
        >
          Go to Sign In
        </Button>
      </div>
    );
  }

  return (
    <form onSubmit={handleSubmit} className="space-y-5">
      {error && (
        <div
          className="bg-red-50 border border-red-200 text-red-700 px-4 py-3 rounded-lg text-sm"
          role="alert"
        >
          {error}
        </div>
      )}

      <Input
        label="New Password"
        type="password"
        name="password"
        placeholder="Enter new password"
        value={formData.password}
        onChange={handleChange('password')}
        required
        autoComplete="new-password"
        disabled={isLoading}
        helperText="Must be at least 8 characters"
      />

      <Input
        label="Confirm Password"
        type="password"
        name="confirmPassword"
        placeholder="Confirm new password"
        value={formData.confirmPassword}
        onChange={handleChange('confirmPassword')}
        required
        autoComplete="new-password"
        disabled={isLoading}
      />

      <Button
        type="submit"
        className="w-full"
        size="lg"
        isLoading={isLoading}
      >
        Reset Password
      </Button>
    </form>
  );
}